var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVialGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_radial_687_2645)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9034 23.6126C13.7527 24.4618 14.7848 24.8864 15.9999 24.8864C17.2013 24.8864 18.23 24.4618 19.0861 23.6126C19.9422 22.7634 20.3702 21.7312 20.3702 20.5161V12.5211C20.8397 12.4659 21.2332 12.2622 21.5508 11.9101C21.8684 11.558 22.0272 11.1403 22.0272 10.657V9.00005C22.0272 8.48915 21.8408 8.04729 21.468 7.67447C21.0952 7.30165 20.6533 7.11523 20.1424 7.11523H11.8575C11.3466 7.11523 10.9047 7.30165 10.5319 7.67447C10.1591 8.04729 9.97266 8.48915 9.97266 9.00005V10.657C9.97266 11.1403 10.1315 11.558 10.449 11.9101C10.7666 12.2622 11.1602 12.4659 11.6296 12.5211V20.5161C11.6296 21.7312 12.0542 22.7634 12.9034 23.6126ZM17.7398 22.7323C17.2427 23.1328 16.6627 23.333 15.9999 23.333C15.2267 23.333 14.5673 23.0603 14.0219 22.5148C13.4765 21.9694 13.2038 21.3032 13.2038 20.5161V12.5419H18.8168V14.0539H16.6213C16.4004 14.0539 16.2174 14.1264 16.0724 14.2713C15.9274 14.4163 15.855 14.5993 15.855 14.8202C15.855 15.0411 15.9274 15.2276 16.0724 15.3794C16.2174 15.5313 16.4004 15.6073 16.6213 15.6073H18.8168V16.85H16.6213C16.4004 16.85 16.2174 16.9225 16.0724 17.0675C15.9274 17.2125 15.855 17.4023 15.855 17.6371C15.855 17.8442 15.9274 18.0237 16.0724 18.1756C16.2174 18.3275 16.4004 18.4034 16.6213 18.4034H18.8168V19.6462H16.6213C16.4004 19.6462 16.2174 19.7221 16.0724 19.874C15.9274 20.0259 15.855 20.2123 15.855 20.4332C15.855 20.6542 15.9274 20.8371 16.0724 20.9821C16.2174 21.1271 16.4004 21.1996 16.6213 21.1996H18.7133C18.5614 21.821 18.2369 22.3319 17.7398 22.7323Z",
    fill: "url(#paint1_linear_687_2645)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_687_2645",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.781 16) rotate(42.4343) scale(20.6205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4FFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_687_2645",
    x1: 9.97266,
    y1: 16.001,
    x2: 22.0271,
    y2: 16.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#019968"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVialGreenIcon);
export default __webpack_public_path__ + "static/media/vial-green-icon.1c0ddefd1433dcb465016540683d0c15.svg";
export { ForwardRef as ReactComponent };